import cdiRaw from '../../public/data/cdi.json'
import type { AmbitoId } from './ambitiStats'

type RawCdi = {
  Info: string
  'Nome Struttura': string
  'Località': string
  'Indirizzo': string
  'Provincia': string
  'Posti accreditati': number
  'Lista attesa Full-time': number
  'Lista attesa Part-time': number
  'Data aggiornamento': string
}

export interface Cdi {
  id: string
  nome: string
  localita: string
  indirizzo: string
  postiAccreditati: number
  listaAttesaFullTime: number
  listaAttesaPartTime: number
  dataAggiornamento: string
  info: string
  ambitoId: AmbitoId
}

function resolveAmbitoId(localita: string): AmbitoId {
  const loc = localita.trim().toUpperCase()
  const MONZA = ['MONZA', 'BRUGHERIO', 'VILLASANTA', 'MUGGIO', 'MUGGIÒ']
  const CARATE = ['CARATE', 'BESANA', 'GIUSSANO', 'LISSONE', 'MACHERIO', 'BIASSONO', 'TRIUGGIO', 'VERANO', 'SOVICO']
  const DESIO = ['DESIO', 'BOVISIO', 'CESANO', 'LIMBIATE', 'LENTATE', 'MEDA', 'NOVA MILANESE', 'SEVESO', 'VAREDO']
  const SEREGNO = ['SEREGNO', 'BARLASSINA', 'CERIANO', 'COGLIATE', 'MISINTO', 'LAZZATE']
  const VIMERCATE = ['VIMERCATE', 'AGRATE', 'ARCORE', 'BERNAREGGIO', 'BURAGO', 'CAPONAGO', 'CARNATE', 'CONCOREZZO', 'CORNATE', 'LESMO', 'ORNAGO', 'RONCO', 'SULBIATE', 'USMATE']
  if (MONZA.some(n => loc.includes(n))) return 'monza'
  if (CARATE.some(n => loc.includes(n))) return 'carate'
  if (DESIO.some(n => loc.includes(n))) return 'desio'
  if (SEREGNO.some(n => loc.includes(n))) return 'seregno'
  if (VIMERCATE.some(n => loc.includes(n))) return 'vimercate'
  return 'monza'
}

function slugify(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}

export const CDI_LIST: Cdi[] = (cdiRaw as RawCdi[]).map((entry, index) => ({
  id: `${slugify(entry['Nome Struttura'])}-${index}`,
  nome: entry['Nome Struttura'],
  localita: entry['Località'],
  indirizzo: entry['Indirizzo'],
  postiAccreditati: entry['Posti accreditati'] ?? 0,
  listaAttesaFullTime: entry['Lista attesa Full-time'] ?? 0,
  listaAttesaPartTime: entry['Lista attesa Part-time'] ?? 0,
  dataAggiornamento: entry['Data aggiornamento'],
  info: entry['Info'],
  ambitoId: resolveAmbitoId(entry['Località']),
}))
